import React from 'react';
import { PageTransition } from '../components/PageTransition';
export function PrivacyPolicyPage() {
  return <PageTransition data-id="element-671">
      <div className="pt-32 pb-24 min-h-screen bg-dark-700" data-id="element-672">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-673">
          <div className="mb-12" data-id="element-674">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-675">
              Privacy Policy
            </h1>
            <div className="w-24 h-1 bg-gold-500 rounded-full mb-6" data-id="element-676"></div>
            <p className="text-white/60" data-id="element-677">Last updated: March 2026</p>
          </div>

          <div className="prose prose-invert prose-gold max-w-none space-y-8 text-white/80" data-id="element-678">
            <section data-id="element-679">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-680">
                1. Our Commitment to Your Privacy
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-681">
                At 3 Doves Podcast, we deeply value the trust you place in us.
                Whether you are a listener, a guest, a donor, or a volunteer,
                your privacy is of the utmost importance to our ministry.
              </p>
              <div className="bg-dark-600 border-l-4 border-gold-500 p-6 rounded-r-lg my-6" data-id="element-682">
                <p className="text-white font-medium text-lg m-0" data-id="element-683">
                  We do not sell anyone's information. Any emails or calls are
                  not sold. All volunteer information is strictly confidential
                  and is not sold to any third parties.
                </p>
              </div>
            </section>

            <section data-id="element-684">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-685">
                2. Information We Collect
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-686">
                We only collect information that you voluntarily provide to us,
                which may include:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-687">
                <li data-id="element-688">
                  Name and contact information (such as email address and phone
                  number) when you reach out to us, subscribe to updates, or
                  volunteer.
                </li>
                <li data-id="element-689">
                  Donation information when you choose to financially support
                  our mission.
                </li>
                <li data-id="element-690">Communication records when you call or email our team.</li>
              </ul>
            </section>

            <section data-id="element-691">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-692">
                3. How We Use Your Information
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-693">
                The information we collect is used solely for the purpose of
                fulfilling our mission and serving you better. This includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-694">
                <li data-id="element-695">
                  Sending you podcast updates, newsletters, and ministry
                  announcements (only if you have opted in).
                </li>
                <li data-id="element-696">Coordinating volunteer efforts and outreach programs.</li>
                <li data-id="element-697">Processing donations and providing tax receipts.</li>
                <li data-id="element-698">
                  Responding to your inquiries, prayer requests, or feedback.
                </li>
              </ul>
            </section>

            <section data-id="element-699">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-700">
                4. Data Security
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-701">
                We implement appropriate technical and organizational security
                measures to protect your personal information against
                unauthorized access, alteration, disclosure, or destruction. We
                treat your personal stories, contact details, and volunteer data
                with the highest level of respect and security.
              </p>
            </section>

            <section data-id="element-702">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-703">
                5. Third-Party Services
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-704">
                We may use trusted third-party services (such as secure payment
                processors or email delivery systems) to help operate our
                ministry. These services only have access to the information
                necessary to perform their specific tasks and are obligated not
                to disclose or use it for any other purpose.
              </p>
            </section>

            <section data-id="element-705">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-706">
                6. Contact Us
              </h2>
              <p className="leading-relaxed" data-id="element-707">
                If you have any questions about this Privacy Policy or how we
                handle your information, please contact us. We are always happy
                to provide clarity and ensure you feel secure in your
                interactions with 3 Doves Podcast.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageTransition>;
}